import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("defs", null, [
      _createElementVNode("path", {
        id: "hide_svg__a",
        d: "m3.138 2-.943.943 18.667 18.666.943-.942-4.017-4.017c2.73-1.85 4.078-4.434 4.096-4.469a.67.67 0 0 0-.029-.79c-.069-.112-3.91-6.253-9.855-6.253-1.687 0-3.2.5-4.51 1.214zM12 7.138a4.667 4.667 0 0 1 4.667 4.667 4.62 4.62 0 0 1-.938 2.786l-1.928-1.928c.125-.26.199-.55.199-.858a2 2 0 0 0-2-2c-.309 0-.599.073-.858.199L9.214 8.076A4.62 4.62 0 0 1 12 7.138m-6.7.717C3.32 9.522 2.184 11.33 2.147 11.39a.67.67 0 0 0-.035.783c.011.024 3.235 6.3 9.889 6.3a10 10 0 0 0 3.346-.57l-1.725-1.726A4.6 4.6 0 0 1 12 16.47a4.667 4.667 0 0 1-4.667-4.666c0-.571.108-1.115.296-1.621z"
      })
    ], -1),
    _createElementVNode("use", { "xlink:href": "#hide_svg__a" }, null, -1)
  ])))
}
export default { render: render }